import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "toolbar",
  id: "kt_toolbar"
}
const _hoisted_2 = {
  "data-kt-swapper": "true",
  "data-kt-swapper-mode": "prepend",
  "data-kt-swapper-parent": "{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}",
  class: "page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0"
}
const _hoisted_3 = {
  key: 0,
  class: "h-20px border-gray-200 border-start mx-4"
}
const _hoisted_4 = {
  key: 1,
  class: "breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1"
}
const _hoisted_5 = { class: "breadcrumb-item pe-3" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Home ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("li", { class: "breadcrumb-item" }, null, -1)
const _hoisted_8 = {
  key: 0,
  class: "breadcrumb-item"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, " > ", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 0,
  class: "breadcrumb-item text-muted"
}
const _hoisted_12 = { class: "breadcrumb-item pe-3 text-dark" }
const _hoisted_13 = { class: "d-flex align-items-center py-1" }
const _hoisted_14 = { class: "me-4" }
const _hoisted_15 = {
  href: "#",
  class: "btn btn-sm btn-flex btn-light btn-active-primary fw-bolder",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_16 = { class: "svg-icon svg-icon-5 svg-icon-gray-500 me-1" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Filter ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Dropdown1 = _resolveComponent("Dropdown1")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: "kt_toolbar_container",
      class: _normalizeClass([{
        'container-fluid': _ctx.toolbarWidthFluid,
        'container-xxl': !_ctx.toolbarWidthFluid,
      }, "d-flex flex-stack"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.breadcrumbs)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3))
          : _createCommentVNode("", true),
        (_ctx.breadcrumbs)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
              _createElementVNode("li", _hoisted_5, [
                _createVNode(_component_router_link, {
                  to: "/dashboard",
                  class: "text-muted text-hover-primary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                })
              ]),
              _hoisted_7,
              (_ctx.item != 'NA')
                ? (_openBlock(), _createElementBlock("li", _hoisted_8, _hoisted_10))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breadcrumbs, (item, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                  (item != 'NA')
                    ? (_openBlock(), _createElementBlock("li", _hoisted_11, _toDisplayString(item), 1))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128)),
              _createElementVNode("li", _hoisted_12, _toDisplayString(_ctx.title), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("a", _hoisted_15, [
            _createElementVNode("span", _hoisted_16, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen031.svg" })
            ]),
            _hoisted_17
          ]),
          _createVNode(_component_Dropdown1)
        ])
      ])
    ], 2)
  ]))
}